import { FC, useEffect, useRef } from 'react';
import { ILazyImageProps } from './interface';
import site from 'pro/config/site';
import { transImageSrc } from 'base/utils/trans-path';

const interval = 500; //毫秒
const waitMinutes = 3; //分钟

const clear = (img: HTMLImageElement) => {
    img.onload = null;
    img.onerror = null;
    img.src = site.placeHolderImage;
};

export const LazyImage: FC<ILazyImageProps> = props => {
    const {
        src,
        alt,
        onChangeStatus,
        lazy: propsLazy = true,
        lazyOffset = 300,
        waitLoad = false,
        calcSize = false,
        width,
        height,
        fetchPriority,
        ...rest
    } = props;

    const lazy = propsLazy && fetchPriority !== 'high';
    const imgRef = useRef<HTMLImageElement>(null);

    useEffect(() => {
        if (!src || !imgRef.current || !lazy) {
            return;
        }
        // src 变化时回到初始状态
        clear(imgRef.current);
        onChangeStatus?.('loading');

        const ob = new IntersectionObserver(
            (entries) => {
                for (let entry of entries) {
                    if (entry.isIntersecting) {
                        const img = entry.target as HTMLImageElement
                        let dataSrc = img.dataset.src as string;
                        if (calcSize) {
                            dataSrc = transImageSrc(src, img.offsetWidth, 2);
                        }

                        let counter = 0;
                        const load = (src: string) => {
                            counter++;
                            img.src = src;

                            img.onload = function() {
                                img.onload = null;
                                onChangeStatus?.('complete');
                            };
                            img.onerror = function() {
                                clear(img); //加载失败和加载中样式相同

                                if (waitLoad && (counter * interval) < waitMinutes * 60 * 1000) {
                                    setTimeout(() => {
                                        load(dataSrc + '?v=' + counter);
                                    }, interval);
                                } else {
                                    onChangeStatus?.('error');
                                }
                            };
                        };

                        load(dataSrc);
                        ob.unobserve(img);
                    }
                }
            },
            {
                root: null, // 相对于整个视口进行判断
                rootMargin: typeof lazyOffset === 'number' ? `${lazyOffset}px` : lazyOffset, // 元素进入视口一段距离即触发
                threshold: 0, // 元素完全进入视口时触发
            },
        );
        ob.observe(imgRef.current);
        return () => {
            ob.disconnect();
        }
    }, [src]);



    return (
        <img
            ref={imgRef}
            src={lazy ? site.placeHolderImage : src}
            data-src={src}
            alt={alt}
            // @ts-ignore
            fetchpriority={fetchPriority}
            {...rest}
        />
    )
}